import React from "react";
import { graphql } from "react-relay";

import { faHubspot } from "@awesome.me/kit-4c83d50d0d/icons/classic/brands";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { ActionItemIntegration } from "~/integrations/actionItemIntegration";
import type { IntegrationDetailsType } from "~/stream/StreamSettings/ActionItemIntegrations";

import { HubspotTaskActionItemIntegrationLinkWidget } from "./Widget";

import styles from "./hubspotTask.module.css";

graphql`
	fragment hubspotTaskSpecificData on HubspotTaskActionItemIntegrationSpecificDataNode {
		__typename
		externalTaskId
		hubspotUrl
	}
`;

function useHubspotTaskStreamIntegrationDetails(_integrationOrAsanaStream: IntegrationDetailsType): {
	containerTitle: string;
	createdBy: string;
	includeAiGenerated: boolean;
} {
	// This integration doesn't have a series level integration, so we don't need to fetch any series details
	throw new Error("useIntegrationDetails hook is not defined for Hubspot Task");
}

export const hubspotTask: ActionItemIntegration = {
	key: "HUBSPOT_TASK",
	logo: <FontAwesomeIcon icon={faHubspot} className={styles.logo} />,
	billingFeatureName: "hubspot_integration",
	displayName: "Hubspot",
	externalActionItemName: "task",
	externalContainerType: "list",
	renderPill: HubspotTaskActionItemIntegrationLinkWidget,
	useIntegrationDetails: useHubspotTaskStreamIntegrationDetails,
};

export default hubspotTask;
